import { useContext, useState } from 'react'; 
//import classNames from 'classnames';
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';

import { Input, Label, Radio } from '../../common/form-helpers';
import { FormContext } from '../../common/form-helpers/Form';
import { StatusIcon, lookupStatusName } from './ReservationTable';
import { ReservationOps } from './EditReservation';

import * as choiceApi from '../../api/choice';

import './EditReservation.scss';
import { BootstrapIcon } from '../BootstrapIcon';





function EditGuest({
    guestIndex,
    onClose,
    statusId,
}) {
    const basePath = `/guests/${guestIndex}`;

    return (
        <Modal size="sm" show={guestIndex!==null} onHide={onClose}>
            <Modal.Header closeButton closeVariant='white'>
                <Modal.Title>Edit Guest</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="ifta-form">
                    <Row>
                        <Col>
                            <Input name={`${basePath}/firstName`} />
                            <Label name={`${basePath}/firstName`}>First Name</Label>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col>
                            <Input name={`${basePath}/lastName`} />
                            <Label name={`${basePath}/lastName`}>Last Name</Label>
                        </Col>
                    </Row>
                    {/* <Row className="mt-4">
                        <Col>
                            <Input name={`${basePath}/dob`} type="date" />
                            <Label name={`${basePath}/dob`}>Birthday</Label>
                        </Col>
                    </Row> */}

                    <Row className="mt-3">
                        <Col className="chip-row">
                            <Radio key={'Male'} name={`${basePath}/genderId`} id={`${basePath}/genderId/Male`} value={'1'} title={'Male'} />
                            <Radio key={'Female'} name={`${basePath}/genderId`} id={`${basePath}/genderId/Female`} value={'2'} title={'Female'} />
                        </Col>
                    </Row>

                    <ReservationOps basePath={basePath} statusId={statusId} />

                    <Row>
                        <Col>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="d-flex justify-content-end w-100">
                    {/* <div>
                        <Button variant="outline-danger" onClick={() => cancelGuest(guestIndex)}>
                            <BootstrapIcon icon="trash" /> Cancel Guest
                        </Button>
                    </div> */}
                    <div>
                        <Button variant="primary" onClick={() => onClose(guestIndex)}>
                            Done
                        </Button>
                        {/* <Button className="ms-2" variant="primary" onClick={() => reserveGuest(guestIndex)}>
                            Save
                        </Button> */}
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}



// TODO: we will want the guest record to save and then refresh the parent
export function Guests({
    name,
    eventAllowGuests
}) {
    const { initial, current, setFormVal } = useContext(FormContext);
    const [ guestIndex, setGuestIndex ] = useState(null);
    const guests = current?.guests;
    const memberResStatus = current.statusId;

    const allowGuests = eventAllowGuests && (
        (memberResStatus === choiceApi.RESERVATION_STATUS_PENDING) ||
        (memberResStatus === choiceApi.RESERVATION_STATUS_CONFIRMED) ||
        (memberResStatus === choiceApi.RESERVATION_STATUS_ARRIVED) ||
        (memberResStatus === choiceApi.RESERVATION_STATUS_PREPAID)
    );


    if (!eventAllowGuests) {
        return <div>Guests are not allowed at this event.</div>
    }
    
    if (!guests || !allowGuests) {
        return null;
    }

    const currGuest = guests.find((x,i) => i === guestIndex) ?? { id: 0};
    const initGuest = initial?.guests?.find((x) => currGuest.id === x.id) ?? { statusId: choiceApi.RESERVATION_STATUS_PENDING }


    const addGuest = () => {
        const newGuest = { id: 0, firstName: "", lastName: "", genderId: choiceApi.GENDER_MALE, statusId: choiceApi.RESERVATION_STATUS_PENDING };
        const updateGuests = [ ...guests, newGuest ];
        setFormVal(name, updateGuests);
        setGuestIndex(updateGuests.length - 1)
    }

    const displayGuests = guests.length === 0 ? <div>No Guests</div> : guests.map((x, i) => {
        return (
            <ListGroup.Item key={`guest-${i}`} onClick={() => setGuestIndex(i)}>
                <div className="d-flex justify-content-between">
                    <div className='fw-bold'>
                        {x.firstName} {x.lastName}
                    </div>
                    <div className="d-flex">
                        <StatusIcon statusId={x.statusId} /> {lookupStatusName(x.statusId)}
                        <div className="ms-3"><BootstrapIcon icon={"pencil"} /></div>
                    </div>
                </div>
            </ListGroup.Item>
        )
    });

    const handleClose = () => {
        // If this guest hasn't been saved yet, then it's possible to "delete" them locally before we save them
        const selectedGuest = current.guests[guestIndex];
        if (selectedGuest.id === 0 &&
                (
                    selectedGuest.statusId === choiceApi.RESERVATION_STATUS_CANCELED 
                )
            ) {
            const updateGuests = current.guests.filter((_, j) => guestIndex !== j)
            setFormVal(name, updateGuests);
        }

        setGuestIndex(null)
    }




    return (
        <Container className="guest-container g-0 mt-2" fluid>
            <b>Guests:</b>

            <ListGroup className="my-2 guest-list">
                {displayGuests}
            </ListGroup>

            <EditGuest guestIndex={guestIndex} onClose={handleClose} statusId={initGuest.statusId} />

            <Row className="pt-2">
                <Col xs={12} className="text-end">
                    <Button variant="outline-primary" onClick={addGuest} disabled={!allowGuests}><BootstrapIcon icon="plus-lg" /> Add Guest</Button>
                </Col>
            </Row>
        </Container>
    )
}
